var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_154_254",
    "data-name": "Component 154 \\u2013 254",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24355",
    "data-name": "Group 24355",
    transform: "translate(-56 69) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8602",
    "data-name": "Rectangle 8602",
    width: 24,
    height: 24,
    transform: "translate(45 56)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24354",
    "data-name": "Group 24354",
    transform: "translate(-1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(49 65)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(56 65)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(63 65)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore4);
export default __webpack_public_path__ + "static/media/more-4.84aa7f20.svg";
export { ForwardRef as ReactComponent };